import React from "react";
import "./style.scss";

const Loader = () => {
  return (
    <div className="loader__wrapper">
      <div className="loader"></div>
    </div>
  );
};

export default Loader;
